import { apiUrl, resolveTenantSlug } from './api';

export interface PublicInstitution { id: string; name: string; type: string }

export interface AdmissionsOpen {
  open: boolean;
  applicationFeePaise: number;
  /**
   * ⚠ THE FIRST ONE ALPHABETICALLY, kept only so a cached older build still works. The server used
   * to send "whichever institution the database returned first" and this form submitted against it
   * — so on a trust with a school and a college, every website enquiry landed in one of them by row
   * order. Read `institutions` instead.
   */
  institutionId: string | null;
  institutionName: string | null;
  /** Every live institution, ordered by name. One entry = no question to ask. */
  institutions?: PublicInstitution[];
}

export interface EnquiryBody {
  institutionId: string;
  applicantName: string;
  seekingClass: string;
  guardianName: string;
  guardianMobile: string;
  guardianEmail?: string | null;
  dateOfBirth?: string | null;   // yyyy-mm-dd
  gender?: string | null;
  address?: string | null;
  previousSchool?: string | null;
  notes?: string | null;
}

// These endpoints are PUBLIC (no auth) — the enquiry form runs before any login. We send the tenant
// header so the backend resolves the school, but never an Authorization token.
async function pub<T>(method: 'GET' | 'POST', path: string, body?: unknown): Promise<T> {
  const slug = resolveTenantSlug();
  const res = await fetch(apiUrl(path), {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(slug ? { 'X-Tenant': slug } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let message = 'Something went wrong. Please try again.';
    try { const j = await res.json(); message = j.message || j.error || message; } catch { /* */ }
    throw new Error(message);
  }
  return (await res.json()) as T;
}

export const publicAdmissionsApi = {
  open: () => pub<AdmissionsOpen>('GET', '/api/public/admissions/open'),
  submit: (body: EnquiryBody) => pub<{ reference: string; message: string }>('POST', '/api/public/admissions/enquiry', body),
};
